import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, BarChart3, ChevronRight, FileSearch, Star, TrendingUp } from 'lucide-react';
import AdSlot from '../advertisement/AdSlot';

export const SME_TOOLS = [
  { label: 'SME GMP Tracker', note: 'Grey market rates for SME issues', to: '/sme-ipo-gmp', icon: TrendingUp },
  { label: 'SME Subscription', note: 'Category-wise bidding demand', to: '/sme-ipo-subscription', icon: BarChart3 },
  { label: 'Upcoming SME IPOs', note: 'Opening soon & SME DRHP pipeline', to: '/sme-upcoming-ipos', icon: FileSearch },
  { label: 'SME IPO Reviews', note: 'Broker calls for SME issues', to: '/sme-ipo-reviews', icon: Star },
];

// Stacks two-up on tablets when it drops below the table, one column beside it on wide screens
export const SmeSidebar = ({ className = '' }) => (
  <aside className={`grid grid-cols-1 md:grid-cols-2 min-[1440px]:grid-cols-1 gap-5 items-start ${className}`} aria-label="SME tools and partners">
    {/* Partner ad (GET /api/ads): dedicated SME slot first, then the shared one */}
    <AdSlot slotId={['sme-ipos-sidebar-top', 'incontent']} variant="compact" />

    <section aria-labelledby="sme-tools-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
      <h2 id="sme-tools-heading" className="text-xs font-extrabold uppercase tracking-wider text-slate-700">
        SME Research Tools
      </h2>
      <ul className="mt-3 divide-y divide-slate-100">
        {SME_TOOLS.map(({ label, note, to, icon: Icon }) => (
          <li key={label}>
            <Link to={to} className="flex items-center gap-3 py-2.5 group">
              <span className="w-8 h-8 rounded-lg bg-teal-50 text-[#008080] flex items-center justify-center shrink-0">
                <Icon className="w-4 h-4" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-semibold text-slate-800 group-hover:text-[#008080] truncate">{label}</span>
                <span className="block text-[11px] text-slate-400 truncate">{note}</span>
              </span>
              <ChevronRight className="w-4 h-4 text-slate-300 group-hover:text-[#008080] shrink-0" />
            </Link>
          </li>
        ))}
      </ul>
    </section>

    <AdSlot slotId={['sme-ipos-sidebar-bottom', 'infeed']} variant="compact" />

    <section aria-labelledby="sme-liquidity-heading" className="rounded-2xl border border-amber-200 bg-amber-50/70 p-4 sm:p-5">
      <h2 id="sme-liquidity-heading" className="flex items-center gap-2 text-sm font-bold text-slate-900">
        <AlertTriangle className="w-4 h-4 text-amber-600 shrink-0" aria-hidden="true" />
        SME Platform Liquidity Risk
      </h2>
      <p className="mt-2 text-xs text-amber-800/90 leading-relaxed">
        SME shares trade in large lots, so exiting a position needs a buyer for the whole lot. Post-listing liquidity is far
        thinner than on the main board. Never invest borrowed capital.
      </p>
    </section>
  </aside>
);

export default SmeSidebar;
